module.exports = __webpack_public_path__ + "img/Foreigner_Sm.5ab689cb.svg";